import { BaseData } from 'src/app/shared/models/base-data';

export class ContactInfoUpdateConfirmData extends BaseData { }